export function formatTimeInMMSS(timeInSeconds: number | string): string {
  const timeInMilliseconds = Number(timeInSeconds) * 1000;
  const formattedTime = new Intl.DateTimeFormat('default', { minute: 'numeric', second: 'numeric' }).format(timeInMilliseconds);
  return formattedTime;
}

export function getTimeInMs(datetime: string): number {
  const [year, month, day, hour, minute, second, millisecond] = datetime.split(/\D/).map((digit) => Number(digit));
  return new Date(year, month - 1, day, hour, minute, second, millisecond).getTime();
}
